import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to conditionally combine css classes into a single string and remove conflicting tailwind classes.
 *
 * ```tsx
 * import { cn } from '@utils/cn';
 *
 * type Props = {
 *   color: 'red' | 'blue';
 *   wayMorePadding: boolean;
 * };
 *
 * export function MyButton({ color, wayMorePadding }: Props): JSX.Element {
 *   return (
 *     <button
 *       className={cn('border border-solid px-4 py-2', {
 *         'bg-red-500': color === 'red',
 *         'bg-blue-500': color === 'blue',
 *         'px-20 py-10': wayMorePadding,
 *       })}
 *     >
 *       My Button
 *     </button>
 *   );
 * }
 *
 * // color === 'red' && wayMorePadding === false -> 'border border-solid px-4 py-2 bg-red-500'
 * // color === 'blue' && wayMorePadding === true -> 'border border-solid px-20 py-10 bg-blue-500'
 * ```
 **/
export function cn(...args: ClassValue[]) {
  return twMerge(clsx(args));
}
